import { useQuery } from '@tanstack/react-query';
import { tenantsApi } from '../api/tenants.api';
import type { TenantPaginationParams } from '../types/tenants.types';
import { tenantsKeys } from './queryKeys';

export const useTenants = (params: TenantPaginationParams = {}) => {
  const {
    page = 1,
    pageSize = 10,
    status,
    isActive,
    countryId,
    planId,
    searchTerm,
    createdFrom,
    createdTo,
  } = params;

  const filters = {
    page,
    pageSize,
    status,
    isActive,
    countryId,
    planId,
    searchTerm,
    createdFrom,
    createdTo,
  };

  const { data, isLoading, error } = useQuery({
    queryKey: tenantsKeys.list(filters),
    queryFn: () =>
      tenantsApi.getTenants({
        page,
        pageSize,
        status,
        isActive,
        countryId,
        planId,
        searchTerm,
        createdFrom,
        createdTo,
      }),
  });

  return {
    tenants: data?.data?.items ?? [],
    pagination: {
      page: data?.data?.page ?? 1,
      pageSize: data?.data?.pageSize ?? 10,
      totalCount: data?.data?.totalCount ?? 0,
      totalPages: data?.data?.totalPages ?? 0,
      hasPreviousPage: data?.data?.hasPreviousPage ?? false,
      hasNextPage: data?.data?.hasNextPage ?? false,
      firstItemOnPage: data?.data?.firstItemOnPage,
      lastItemOnPage: data?.data?.lastItemOnPage,
    },
    isLoading,
    error,
  };
};
